export default {
  setProductLists(state,playload){

    state.productsListsPos = playload.productsLists;

  }
};
